import { render, staticRenderFns } from "./cell-unit.vue?vue&type=template&id=63a20b34&scoped=true"
import script from "./cell-unit.vue?vue&type=script&lang=js"
export * from "./cell-unit.vue?vue&type=script&lang=js"
import style0 from "./cell-unit.vue?vue&type=style&index=0&id=63a20b34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a20b34",
  null
  
)

export default component.exports